import { render, staticRenderFns } from "./AttendExam.vue?vue&type=template&id=19fdb288&scoped=true&"
import script from "./AttendExam.vue?vue&type=script&lang=js&"
export * from "./AttendExam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fdb288",
  null
  
)

export default component.exports